import { Card, Typography, Select, DatePicker, Button, Empty, Pagination } from "antd";
import { Form } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import SortingArrow from "../../Common/SortingArrow";
import { useEffect, useState } from "react";
import { addDeleteGetLocalStorage, storageKeys } from "../../utils/global/localData";
import { checkPermissionAction } from "../../utils/helper/utils";
import { jwtDecode } from "jwt-decode";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";
import { capitalizeName, formatDateFunction } from "../../utils/helper/utils";
import { saveAs } from "file-saver";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import { usePersistentFilters } from "../../Hooks/commonApiHooks/usePersistentFilters";
const selectStatus = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "settled",
    label: "Settled",
  },
  {
    value: "planned",
    label: "Planned",
  },
];

const VendorPayouts = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [allVendor, setAllVendor] = useState([]);

  const [permissionJson, setPermissionJson] = useState([]);
  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
      setPermissionJson(permissionJson);
    }
    if (!checkPermissionAction("Vendor Payouts", permissionJson, "view")) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllVendorPayout = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_VENDOR_PAYOUT.GET_ALL_VENDOR_PAYOUT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllVendorPayout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const { RangePicker } = DatePicker;
  const navigate = useNavigate();

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };
  const handleDateChange = (dates, dateStrings) => {
    const [startdate, enddate] = dateStrings; // Get the date strings from the RangePicker

    // Update the filter with the selected start and end dates
    setInputData((prevState) => ({
      ...prevState,
      periodStartDate: startdate, // Set the start date
      periodEndDate: enddate, // Set the end date
    }));
  };

  const exportAllVednorPayout = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
      };
      let response = await globalRequest(Apis.MANAGE_VENDOR_PAYOUT.EXPORT_ALL_VENDOR_PAYOUT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.length === 0) {
          toast.error("No data found for export");
        } else {
          let exportData = [];

          for (let item of apiResponse?.data) {
            exportData.push({
              'Sales Period': `${formatDateFunction(item?.peroidStartDate)}-${formatDateFunction(item?.peroidEndDate)}`,
              'Total Order': item?.totalOrder,
              'Sales Amount': item?.salesAmount,
              'Expected Payout Amount': item?.expectedPayoutAmount,
              'Actual Payout Date': item?.actualPayoutDate ? formatDateFunction(item?.actualPayoutDate) : "-",
              'Actual Payout Amount': item?.actualPayoutAmount ? item?.actualPayoutAmount : 0,
              'Status': item?.status,
              'Adjustment Reason': item?.payoutNotes ? item?.payoutNotes : "-",
            });
          }

          const headers = Object.keys(exportData[0]).join(","); // Extract headers
          const rows = exportData.map((row) =>
            Object.values(row)
              .map((value) => `"${value}"`) // Escape values
              .join(",")
          );
          const csvContent = [headers, ...rows].join("\n");

          // Create a Blob and save file
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          saveAs(blob, "vendor_payout.csv");
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (apiResponse.data) {
        apiResponse.data = [{ id: "", vendorDetail: { storeName: "All" } }, ...apiResponse.data];
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.vendorDetail?.storeName, //item?.firstName + " " + item.lastName,
          };
        });
        setAllVendor(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllVendor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePersistentFilters({
      form,
      location,
      currentPath: "/vendor-payouts",
      addPath: "/vendor-payouts-detail",
      editPathPrefix: "/vendor-payouts-detail",
      storageKey: "payout_filters",
      inputData,
      setInputData,
      paginationModel,
      setPaginationModel,
  });

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Vendor Payouts
            </Typography>
          </div>
          <div>
            <RangePicker className="mx-1.5 cursor-pointer" onChange={handleDateChange} />
            <Select
              style={{
                width: 200,
              }}
              placeholder="Store Name"
              options={allVendor}
              showSearch
              filterOption={(input, allVendor) => (allVendor?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              className="mx-1.5 cursor-pointer my-2 sm:my-0"
              value={form.getFieldValue("vendor_id")}
              onChange={(e) => {
                form.setFieldValue("vendor_id", e);
                setInputData((prev) => ({ ...prev, vendor_id: e }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            <Select
              style={{
                width: 100,
              }}
              placeholder="Status"
              options={selectStatus}
              showSearch
              filterOption={(input, selectStatus) => (selectStatus?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              className="mx-1.5 cursor-pointer my-2 sm:my-0"
              value={form.getFieldValue("status")}
              onChange={(e) => {
                form.setFieldValue("status", e);
                setInputData((prev) => ({ ...prev, status: e }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            {/* <Search
              placeholder="Search by  Vendor"
              onSearch={onSearch}
              style={{
                width: window.innerWidth < 768 ? "100%" : 300,
              }}
              className="mx-1.5 cursor-pointer my-2 sm:my-0"
              onChange={(e) => {
                const value = Validation.strFormat(e.target.value, "trim");
                handleSearchDebounced(value); // Debounced function
              }}
            /> */}
            {checkPermissionAction("Vendor Payouts", permissionJson, "export") ? (
              <Button type="primary" size={14} className="mx-1.5 cursor-pointer" onClick={exportAllVednorPayout}>
                Export
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap vertical-top">
                  Sales Period <SortingArrow onSort={(order) => handleSort("peroidStartDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Total Order <SortingArrow onSort={(order) => handleSort("totalOrder", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Vendor Name <SortingArrow onSort={(order) => handleSort("name", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Sales Amount <SortingArrow onSort={(order) => handleSort("salesAmount", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Expected Payout Date <SortingArrow onSort={(order) => handleSort("expectedPayoutDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Actual Payout Date <SortingArrow onSort={(order) => handleSort("actualPayoutDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Expected Payout Amount <SortingArrow onSort={(order) => handleSort("expectedPayoutAmount", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Actual Payout Amount <SortingArrow onSort={(order) => handleSort("actualPayoutAmount", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b text-gray-700" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                    <td
                      className="px-3 py-4 vertical-top font-semibold cursor-pointer whitespace-nowrap"
                      onClick={() => navigate("/vendor-payouts-detail/" + item?.id)}
                    >
                      {formatDateFunction(item?.peroidStartDate, "dd/mm/yyyy")} To {formatDateFunction(item?.peroidEndDate, "dd/mm/yyyy")}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.totalOrder}</td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.user?.vendorDetail?.storeName}</td>
                    <td className="px-3 py-4 vertical-top">{item?.salesAmount != null ? (item?.salesAmount).toFixed(2) : 0}</td>
                    <td className="px-3 py-4 vertical-top">{formatDateFunction(item?.expectedPayoutDate, "dd/mm/yyyy")}</td>
                    <td className="px-3 py-4 vertical-top">
                      {item?.actualPayoutDate ? formatDateFunction(item?.actualPayoutDate, "dd/mm/yyyy") : ""}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      {item?.expectedPayoutAmount != null ? (item?.expectedPayoutAmount).toFixed(2) : 0}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      {item?.actualPayoutAmount != null ? (item?.actualPayoutAmount).toFixed(2) : 0}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <span
                        className={`flex items-center ${
                          item?.status === "planned" ? "bg-blue-50" : "bg-green-50"
                        } text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]`}
                      >
                        {capitalizeName(item?.status)}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
              onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
            />
          </div>
        ) : null}
      </Card>
    </>
  );
};
export default VendorPayouts;
